import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import CloseIcon from '@mui/icons-material/Close';
import Button from 'components/Button';
import IconButton from 'components/IconButton';
import VideoPlayer from 'components/VideoPlayer';
import useAlert from 'hooks/useAlert';
import LearnMore from 'modules/settings/components/sender-profile/LearnMore';
import DLCStatus from 'constants/10-dlc-status';

const useSenderProfileStatus = () => {
  const account = useSelector((state) => state.settings.account);
  const user = useSelector((state) => state.user.user);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const alert = useAlert();
  const status = account.account_10dlc_status;
  const shouldShowRegistrationBanner =
    isLoggedIn && user.user_onboarded && DLCStatus.NEED_INFO === status;

  useEffect(() => {
    if (shouldShowRegistrationBanner) {
      const d = alert.dialog({
        actions: [],
        render: () => {
          return (
            <Box>
              <IconButton
                sx={{ position: 'absolute', top: 5, right: 5 }}
                icon={<CloseIcon />}
                onClick={() => d.close()}
              />
              <Box mb={3} pt={2}>
                <Typography variant="h2" fontWeight={600}>
                  Complete Your{' '}
                  <span style={{ textDecoration: 'underline' }}>
                    A2P 10-DLC
                  </span>{' '}
                  Registration
                </Typography>
              </Box>
              <Box mb={2} border={4} borderColor="talk.main">
                <VideoPlayer url="https://vimeo.com/textinchurch/10dlc-registration" />
              </Box>
              <Typography paragraph variant="subtitle1" fontWeight={700}>
                Getting Registered Couldn’t Be Easier!
              </Typography>
              <Box textAlign="left" mb={3}>
                <ol>
                  <li>
                    <Typography>
                      Click the button below to register now
                    </Typography>
                    <li>
                      <Typography>
                        Complete the simple form, and we’ll handle the rest
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Have confidence that your messages are delivered quickly
                        & reliably.
                      </Typography>
                    </li>
                  </li>
                </ol>
                <Typography paragraph>
                  Failure to register will result in your messages being flagged
                  as spam or blocked entirely, making it difficult to reach your
                  community.
                </Typography>
                <Typography>
                  Click the orange button below to complete your registration
                  now to ensure your messages avoid carrier SPAM traps.
                </Typography>
              </Box>

              <Stack spacing={2} alignItems="center">
                <Button
                  onClick={() => d.close()}
                  color="cta"
                  component={Link}
                  to="/settings/sender-profile"
                >
                  REGISTER NOW
                </Button>
                <Box width="100%">
                  <LearnMore />
                </Box>
              </Stack>
            </Box>
          );
        },
      });
    }
  }, [shouldShowRegistrationBanner]);

  return {
    shouldShowRegistrationBanner,
    status,
  };
};

export default useSenderProfileStatus;
